export enum PlatformTypeEnum {
  JD = 'JD', // 京东
  TM = 'TMALL', // 天猫
  SN = 'SUNING', // 苏宁
  ZKH = 'ZHENKUNHANG', // 震坤行
  ZCY = 'ZHENGCAIYUN', // 政采云
  DL = 'DELI', // 得力
  JS = 'JISHI', // 集什
  XFS = 'XINFANGSHENG', // 鑫方盛
  ELSE = 'OTHER', // 其他
}

export enum SearchDataValue {
  YES = '1',
  NO = '0',
}
// 中国交建-工业品3201、中国交建-自营3202、中国交建劳保92、能建商城国内A10、能建商城国内B119、能建商城国际121、能建线下（自建）WZ0290
export const NOT_SELECT_PLATFORM = [
  '3201',
  '3202',
  '92',
  '10',
  '119',
  '121',
  'WZ0290',
]
export enum PlatformTypeEnum {
  JD = 'JD', // 京东
  TM = 'TMALL', // 天猫
  SN = 'SUNING', // 苏宁
  ZKH = 'ZHENKUNHANG', // 震坤行
  ZCY = 'ZHENGCAIYUN', // 政采云
  DL = 'DELI', // 得力
  JS = 'JISHI', // 集什
  XFS = 'XINFANGSHENG', // 鑫方盛
  ELSE = 'OTHER', // 其他
}

export enum SearchDataValue {
  YES = '1',
  NO = '0',
}
// 中国交建-工业品3201、中国交建-自营3202、中国交建劳保92、能建商城国内A10、能建商城国内B119、能建商城国际121、能建线下（自建）WZ0290
export const NOT_SELECT_PLATFORM = [
  '3201',
  '3202',
  '92',
  '10',
  '119',
  '121',
  'WZ0290',
]
